import React from "react";
import { useParams } from "react-router-dom";
import { Training_details } from "../TrainingPage/Training_details/Training_datas";
import Skills from "../TrainingPage/Skills/Skills";

const CourseDetails = () => {
  const { slug } = useParams();

  const course = Training_details.find(c => c.slug === slug);

  if (!course) return <h2>Course Not Found</h2>;

  return (
    <div>

      <Skills tools={course.tools} subject={course.sub} />
    </div>
  );
};

export default CourseDetails;